import { lazy } from 'react';

export const DepartmentList = lazy(() => import('./department/DepartmentList'));
export const AddDepartment = lazy(() => import('./department/AddDepartment'));
export const UpdateDepartment = lazy(() => import('./department/UpdateDepartment'));
export const EmployeeList = lazy(() => import('./employee/EmployeeList'));
export const AddEmployee = lazy(() => import('./employee/AddEmployee'));
export const UpdateEmployee = lazy(() => import('./employee/UpdateEmployee'));
export const GroupList = lazy(() => import('./group/GroupList'));
export const AddGroup = lazy(() => import('./group/AddGroup'));
export const UpdateGroup = lazy(() => import('./group/UpdateGroup'));
export const GroupTypeList = lazy(() => import('./group_type/GroupTypeList'));
export const AddGroupType = lazy(() => import('./group_type/AddGroupType'));
export const UpdateGroupType = lazy(() => import('./group_type/UpdateGroupType'));